import { render, staticRenderFns } from "./Empowerment.vue?vue&type=template&id=56ab59e4&scoped=true&"
import script from "./Empowerment.vue?vue&type=script&lang=js&"
export * from "./Empowerment.vue?vue&type=script&lang=js&"
import style0 from "./Empowerment.vue?vue&type=style&index=0&id=56ab59e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab59e4",
  null
  
)

export default component.exports